import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const BannerContainer = styled.div`
  background: #eff3fe;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
  gap: 12px;
  margin-bottom: 32px;

  ${theme.breakpoints.down('md')} {
    margin-bottom: 24px;
  }
`

export const SkeletonBanner = styled.div`
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 32px;
`

export const IconWrapper = styled.div`
  flex-shrink: 0;
  color: #083cbc;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;

  svg {
    width: 20px;
    height: 20px;
  }
`

export const Content = styled.div`
  flex: 1;
`

export const Title = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #262626;
  margin-bottom: 0;
`

export const Description = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #262626;

  strong {
    font-weight: 700;
  }
`
